import InventoriesApiV2 from 'api/v2/admins/inventories-api-v2'
import SelectSearchField from 'components/molecules/select-search-field'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

const InventorySelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ searchInventories, setSearchInventories ] = useState([])
  const [ isSearchLoading, setSearchLoading ]       = useState(false)
  const searchTimeoutRef                            = useRef(null)

  const getInventories = (keyword) => {
    setSearchLoading(true)

    InventoriesApiV2.search(keyword, {
      eligible_for_internal_request: true,
      per_page                     : 50
    })
      .then((response) => {
        setSearchInventories(response.data.inventories || [])
        setSearchLoading(false)
      })
      .catch((error) => {
        setSearchLoading(false)
        alert(error?.response?.data?.message || error.message)
      })
  }

  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.inventory_sku }</span>
      <span className='text-muted'>{ option.product_name }</span>
    </>
  )

  const getSelectedOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.inventory_sku }</span>
      <span className='text-muted'>{ option.product_name }</span>
    </>
  )

  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)

    searchTimeoutRef.current = setTimeout(() => {
      getInventories(searchText)
    }, 400)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search inventory SKU / product SKU / product name'
      dataList={ searchInventories }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionValue={ (option) => option }
      getOptionLabel={ getOptionLabel }
      getSelectedOptionLabel={ getSelectedOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      { ...props }
    />
  )
}

InventorySelectSearchField.propTypes = propTypes
InventorySelectSearchField.defaultProps = defaultProps

export default InventorySelectSearchField
